import styled from "@emotion/styled";

export const Icon = styled.div`
  width: 24px;
  height: 24px;
  background-image: url("/assets/images/flags-sprite-circle.png");

  &.ap {
    border-radius: 50%;
    background-color: #87ceeb;
  }

  &.ax {
    background-image: url("/assets/images/flags/iceland.png");
  }

  &.im {
    background-image: url("/assets/images/flags/isleofman.png");
  }
`;
